import * as Sw from '@radix-ui/react-switch'
import s from './Switch.module.css'

// id + aria are forwarded to the Radix Root, which renders the focusable
// button. <Field> clones them onto its child; without the passthrough a Switch
// inside a Field had no accessible name (UX-01).
export function Switch({ checked, onCheckedChange, disabled, ...aria }: {
  checked?: boolean; onCheckedChange: (c: boolean) => void; disabled?: boolean
  // aria-label for the case <Field> does not cover: a LIST of switches, where
  // the visible text belongs to the row and each control needs a name that says
  // which row it acts on. Six switches all called "Show" are six controls a
  // screen-reader user cannot tell apart (#511's navigation editor).
  id?: string; 'aria-label'?: string
  'aria-describedby'?: string; 'aria-invalid'?: boolean; 'aria-required'?: boolean
}) {
  return (
    <Sw.Root checked={checked} onCheckedChange={onCheckedChange} disabled={disabled} className={s.root} {...aria}>
      <Sw.Thumb className={s.thumb} />
    </Sw.Root>
  )
}
